<div class="filter-box">
  <div class="filter-header pb-3 d-flex align-items-center">
    <div [class]="filterConfig.iconName"></div>
    <div>{{filterConfig.header}}</div>
    <button mat-icon-button>
      <span
        class="reload"
        (click)="onReload()"
      ></span>
    </button>
  </div>
  <div class="filter-form mt-3">
    <ng-content></ng-content>
    <form [formGroup]="form">
      <div class="row">
        <div class="col">
          <div class="row">
            <div
              [class.col-md-4]="![type.trade_lane, type.role].includes(filterConfig.type)"
              [class.col-md-3]="filterConfig.type === type.trade_lane"
              [class.col-md-2]="filterConfig.type === type.role"
              *ngIf="![type.party].includes(filterConfig.type)"
            >
              <div class="form-group">
                <ng-select
                notFoundText="{{'No items found' | translate}}"
                  [items]="filterConfig?.status"
                  bindLabel="label"
                  bindValue="value"
                  placeholder="{{'(All Status)' | translate}}"
                  [searchable]="false"
                  formControlName="status"
                  (change)="onValueChanged($event)"
                >
                </ng-select>
              </div>
            </div>

            @if(filterConfig.type === type.category) {
              <div class="col-md-4">
                <div class="form-group">
                  <ng-select
                  notFoundText="{{'No items found' | translate}}"
                    [items]="filterConfig?.users"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="({{'All Users' | translate}})"
                    formControlName="user_id"
                    (change)="onValueChanged($event)"
                  >
                  </ng-select>
                </div>
              </div>
            }
            <!-- USER MANAGEMENT -->
            @if([type.user, type.role].includes(filterConfig.type)&& filterConfig?.companies) {
              <div class="col-md-4">
                <div class="form-group">
                  <ng-select
                  notFoundText="{{'No items found' | translate}}"
                    [items]="filterConfig?.companies"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="{{'(All Companies)' | translate}}"
                    formControlName="company_id"
                    (change)="onValueChanged($event)"
                  >
                  </ng-select>
                </div>
              </div>
              @if (filterConfig.type === type.role) {
                <div class="col-md-2">
                  <div class="form-group">
                    <ng-select
                    notFoundText="{{'No items found' | translate}}"
                      [items]="filterConfig?.types"
                      bindLabel="name"
                      bindValue="id"
                      placeholder="{{'(All Types)' | translate}}"
                      formControlName="collar_type"
                      (change)="onValueChanged($event)"
                    >
                    </ng-select>
                  </div>
                </div>
              }
              @if(filterConfig?.roles) {
                <div class="col-md-4">
                  <div class="form-group">
                    <ng-select
                    notFoundText="{{'No items found' | translate}}"
                      [items]="filterConfig?.roles"
                      bindLabel="name"
                      bindValue="id"
                      placeholder="{{'(All Roles)' | translate}}"
                      formControlName="role_id"
                      (change)="onValueChanged($event)"
                    >
                    </ng-select>
                  </div>
                </div>
              }
            }
            <!-- COMPANY MANAGEMENT -->
            <ng-container *ngIf="[type.company, type.party].includes(filterConfig.type)">
              <div class="col-md-4">
                <div class="form-group">
                  <ng-select
                  notFoundText="{{'No items found' | translate}}"
                    [items]="personas"
                    bindLabel="title"
                    bindValue="id"
                    placeholder="{{'(All Persona)' | translate}}"
                    formControlName="persona"
                    (change)="onValueChanged($event)"
                  >
                  </ng-select>
                </div>
              </div>
            </ng-container>

            <!-- TRADE LANE MANAGEMENT, FLOW MANAGEMENT -->
            <ng-container
              *ngIf="[type.trade_lane, type.flow, type.company, type.party].includes(filterConfig.type)"
            >
              <div
                [class.col-md-3]="filterConfig.type === type.flow"
                [class.col-md-4]="filterConfig.type !== type.flow"
              >
                <div class="form-group">
                  <ng-select
                  notFoundText="{{'No items found' | translate}}"
                    [items]="countries"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="{{'(All Countries)' | translate}}"
                    formControlName="country"
                    (change)="onValueChanged($event)"
                  >
                  </ng-select>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="filterConfig.type === type.trade_lane && filterConfig.roleLogChainAdmin">
              <div class="col-md-5">
                <div class="form-group">
                  <ng-select
                  notFoundText="{{'No items found' | translate}}"
                    [items]="filterConfig?.companies"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="{{'(All Companies)' | translate}}"
                    formControlName="company_id"
                    (change)="onValueChanged($event)"
                  >
                  </ng-select>
                </div>
              </div>
            </ng-container>
            @if(filterConfig.type === type.company && filterConfig.roleLogChainAdmin) {
              <div class="col-md-4"
              >
                <div class="form-group">
                  <ng-select
                  notFoundText="{{'No items found' | translate}}"
                    [items]="licenceList"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="({{'All Licences' | translate}})"
                    formControlName="licence_type"
                    (change)="onValueChanged($event)"
                  >
                  </ng-select>
                </div>
              </div>
            }
            <div class="col">
              <div class="search">
                <div class="form-group">
                  <input
                    appSearch
                    (search)="onSearch()"
                    type="text"
                    formControlName="search"
                    class="form-control input-search"
                    placeholder="{{'Search' | translate}}"
                  >
                  <div class="search-icon"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="btn-group"
          [class.col-md-3]="filterConfig.type !== type.role"
          [class.col-md-2]="filterConfig.type === type.role"
          *ngIf="!filterConfig?.hiddenBtn"
        >
          <button
            type="button"
            class="btn btn-primary btn-add"
            [class.disable]="filterConfig.buttonDisabled"
            (click)="navigateToAddPage()"
            [title]="filterConfig.buttonTitle"
            *ngIf="addPermission"
          >{{filterConfig.buttonName}}</button>
        </div>
      </div>
    </form>
  </div>
</div>
